import { render, staticRenderFns } from "./DvPhoneField.vue?vue&type=template&id=11a2dee6&lang=pug"
import script from "./DvPhoneField.vue?vue&type=script&lang=js"
export * from "./DvPhoneField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports